import BaseCollectionService from "./base.collection.service";

class RoofStructureService extends BaseCollectionService {
  constructor() {
    super("roofStructureOptions");
  }

  public async deleteBulkRoofStructures(_ids: string[]) {
    const path = `roofStructures-bulk`;
    return await this.request(
      {
        method: "delete",
        url: path,
        data: { _ids }
      },
      { useToken: "access" }
    );
  }
}

export default new RoofStructureService();
